import React from "react";

const TimeSlotSelector = ({ timings, setTutorDetails, tutorDetails }) => {
  const handleTimingChange = (index, field, value) => {
    const updatedTimings = [...tutorDetails.timings];
    updatedTimings[index] = { ...updatedTimings[index], [field]: value };
    setTutorDetails((prevDetails) => ({
      ...prevDetails,
      timings: updatedTimings,
    }));
  };

  const addTimeSlot = () => {
    setTutorDetails((prevDetails) => ({
      ...prevDetails,
      timings: [...prevDetails.timings, { startTime: "", endTime: "" }],
    }));
  };

  return (
    <div className="form-section">
      {timings.map((slot, index) => (
        <div key={index} className="row align-items-center">
          <div className="col-md-5 form-group">
            <input
              type="time"
              value={slot.startTime}
              onChange={(e) =>
                handleTimingChange(index, "startTime", e.target.value)
              }
            />
          </div>
          <div className="col-md-2 form-group">
            <h5> to </h5>
          </div>
          <div className="col-md-5 form-group">
            <input
              type="time"
              value={slot.endTime}
              onChange={(e) =>
                handleTimingChange(index, "endTime", e.target.value)
              }
            />
          </div>
        </div>
      ))}
      <button type="button" className="btn btn-success" onClick={addTimeSlot}>
        + Add Time Slot
      </button>
    </div>
  );
};

export default TimeSlotSelector;
